<template>
  <div class="article-content main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">分类名称</span>
        <Input v-model="searchParams.name" clearable placeholder="请输入文章标题" />
      </div>
      <div class="input-item">
        <span class="label">是否启用</span>
        <RadioGroup v-model="searchParams.isShow" @on-change="searchAjax()">
          <Radio label="">全部</Radio>
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </div>
      <div class="tools-box left">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <Button type="primary" class="btn" @click="$refs.editModal.open({})" v-if="$units.pointAction('content_1_2_1')">+ 新增</Button>
    <div class="tableBox">
      <loading :isShow="tableLoading" />
      <Table ref="selection" :columns="columns" :data="tableData" row-key="id">
        <template slot-scope="{ row }" slot="isShow">
          <i-switch v-model="row.isShow" true-value="1" false-value="0" @on-change="changeItem($event, row)" :disabled="$units.pointAction('content_1_2_2')?false:true"></i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="fixed">
          <div v-if="$units.pointAction('content_1_2_2')">
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-xiangshang" @click="moveType(row, '1')"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidongxiangxia" @click="moveType(row, '2')"></i></span>
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-zhiding" @click="moveType(row, '3')"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidong-zhidi" @click="moveType(row, '4')"></i></span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="$refs.editModal.open(row)" v-if="$units.pointAction('content_1_2_2')">修改</span>
          <span class="table-btn" @click="removeArticle(row)" v-if="$units.pointAction('content_1_2_3')">文章迁移</span>
          <span v-if="$units.pointAction('content_1_2_4') && (row.parentId != 0 || row.children.length == 0)" class="table-btn" @click="editArticle(row)">文章排序</span>
          <span class="table-btn" @click="deleteItem(row)" v-if="$units.pointAction('content_1_2_5')">删除</span>
        </template>
      </Table>
    </div>
    <editModal ref="editModal" @success="getList"></editModal>
    <editArticle ref="editArticle"></editArticle>
    <editType ref="editType" @success="getList()" @add="$refs.editModal.open({})"></editType>
  </div>
</template>

<script>
import editModal from './components/editModal';
import editArticle from './components/editArticle';
import editType from './components/editType';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  components: {
    editModal,
    editArticle,
    editType
  },
  data() {
    return {
      isAll: false,
      tableLoading: false, //表格loading
      searchParams: {},
      columns: [
        {
          title: '分类名称',
          align: 'left',
          key: 'name',
          minWidth: 200,
          tree: true
        },
        {
          title: '是否启用',
          align: 'center',
          slot: 'isShow',
          minWidth: 100
        },
        {
          title: '移动',
          align: 'center',
          slot: 'fixed',
          minWidth: 100
        },
        {
          title: '更新时间',
          align: 'center',
          key: 'updateTime',
          minWidth: 100,
          render(h, params) {
            const date = params.row.updateTime ? params.row.updateTime.substring(0, 16) : '';
            return <span>{date}</span>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 250,
          fixed: 'right'
        }
      ],
      tableData: [],
      parentList: [],
      columnList: [],
      selItem: []
    };
  },
  created() {
    if (!this.$units.pointAction('content_1_2_2') && !this.$units.pointAction('content_1_2_3') && !this.$units.pointAction('content_1_2_4') && !this.$units.pointAction('content_1_2_5')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.searchAjax();
  },
  methods: {
    searchAjax() {
      this.getList();
    },

    // 获取列表数据
    getList() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: 'post',
        data: {
          type: 1,
          ...this.searchParams,
          pageSize: 9999,
          pageNo: 1
        }
      })
        .then(res => {
          this.tableLoading = false;
          this.total = res.total;
          this.tableData = this.handleTableTree(res.data);
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },

    // 处理树形数据
    handleTableTree(arr) {
      return arr.map(item => ({
        ...item,
        _showChildren: true,
        _length: item.parentId == '0' ? arr.length : arr.length,
        children: item.children ? this.handleTableTree(item.children) : []
      }));
    },
    setListParams(params) {
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        params.beginPublishTime = this.searchParams.date[0];
        params.endPublishTime = this.searchParams.date[1];
      }
      if (params.source == '999') {
        params.source = '';
      }
    },
    moveType(row, type) {
      this.$http({
        url: '/buz/cmsColumn/moveColumnOrderNum',
        type: 'POST',
        data: {
          id: row.id,
          type: type,
          parentId: row.parentId
        }
      }).then(res => {
        this.getList();
      });
    },
    removeArticle(row) {
      this.$refs.editType.open(row.id);
    },
    editArticle(row) {
      this.$refs.editArticle.open(row);
    },
    deleteItem(row) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        this.$http({
          url: `/buz/cmsColumn/del`,
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$Message.success('操作成功');
          this.getList();
        });
      });
    },
    changeItem(isShow = 1, item) {
      this.$notice
        .inquiry(`确认更新启用状态？`)
        .then(() => {
          this.$http({
            url: '/buz/cmsColumn/edit',
            type: 'POST',
            data: {
              id: item.id,
              isShow
            }
          }).then(res => {
            this.$notice.success('操作成功');
            this.getList();
          });
        })
        .catch(() => {
          item.isShow = isShow == '1' ? '0' : '1';
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './index';

.btn {
  margin-bottom: 10px;
}
</style>
